module.exports = __webpack_public_path__ + "static/media/x.d543a6cc.svg";